function startOfLocalCalendarDay(date: Date): number {
  return new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
  ).getTime();
}

/** Parses `YYYY-MM-DD` as a local calendar day (API update dates); other strings use Date parsing. */
function parseDayInput(day: Date | string): Date {
  if (day instanceof Date) {
    return day;
  }
  return new Date(day);
}

/**
 * Returns a short label for when something was posted relative to today:
 * "Posted today", "Posted yesterday", or "Posted on {date}" for other calendar days.
 */
export function formatPostedLabelForDay(day: Date | string): string {
  console.log(`Formatting ${day}`);
  const posted = parseDayInput(day);
  if (Number.isNaN(posted.getTime())) {
    return '';
  }

  const today = new Date();
  const postedStart = startOfLocalCalendarDay(posted);
  const todayStart = startOfLocalCalendarDay(today);
  const dayDifference = Math.round(
    (todayStart - postedStart) / (1000 * 60 * 60 * 24),
  );

  if (dayDifference === 0) {
    return 'Posted today';
  }
  if (dayDifference === 1) {
    return 'Posted yesterday';
  }

  const formatted = posted.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
  return `Posted on ${formatted}`;
}
